import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) return;

  const host = window.location.hostname;
  const isProduction = !host.startsWith('staging.') && !host.includes('localhost') && !host.includes('127.0.0.1');
  if (!isProduction) return;

  Sentry.init({
    environment: 'production',
    dsn: SENTRY_DSN,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/.*\.api\.getruta\.com/,
      'https://staging.api.getruta.com',
      'https://api.getruta.com',
    ],
  });
}
